import styled from 'styled-components'
// import { DeviceTypes } from '../../types/state'

interface Props {
	isSelected: boolean
}

export const MaxWidth = styled.div`
	display: flex;
	justify-content: center;
`

export const Main = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1680px;
	margin-top: 70px;
	align-items: center;
`

export const VoteWrapper = styled.div`
	overflow-y: auto;
	max-width: 375px;
	height: 410px;
	box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
		0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
	border-radius: 24px;
	background: #153882;
	align-items: center;
	display: flex;
	justify-content: center;
	flex-direction: column;
	// height: 80vh; //for sticky footer
`

// interface VotedProps {
// 	voted?: boolean
// }

// export const VoteButtonWrapper = styled.button<VotedProps>`
// 	position: relative;
// 	width: 116px;
// 	height: 32px;
// 	left: 7px;
// 	top: 10px;
// 	background: ${(props) => (props.voted ? '#FFB400' : 'transparent')};
// 	color: ${(props) => (props.voted ? 'black' : '#FFB400')};
// 	border: 1px solid #ffb400;
// 	box-sizing: border-box;
// 	border-radius: 5px;
// `

export const HexParent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 49px;
	width: 300px;
	background: #437ddb;
	-webkit-clip-path: polygon(
		10% 5%,
		90% 5%,
		100% 50%,
		90% 95%,
		10% 95%,
		0% 50%
	);
	clip-path: polygon(10% 5%, 90% 5%, 100% 50%, 90% 95%, 10% 95%, 0% 50%);

	//added new
	z-index: 1;
	position: relative;
`
export const HexButton = styled.div<Pick<Props, 'isSelected'>>`
	height: 47px;
	width: 298px;
	background: ${(props) =>
		props.isSelected
			? 'linear-gradient(270deg, #065CEA 0%, #91BAFF 107.04%);'
			: 'linear-gradient(270deg, #142864 0%, #16469c 107.04%)'};
	-webkit-clip-path: polygon(
		10% 5%,
		90% 5%,
		100% 50%,
		90% 95%,
		10% 95%,
		0% 50%
	);
	clip-path: polygon(10% 5%, 90% 5%, 100% 50%, 90% 95%, 10% 95%, 0% 50%);
`
export const HexButtonText = styled.p`
	width: 300px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	height: inherit;
	margin: 0;
	color: white;
	font-size: 14px;
`

export const Question = styled.div`
	font-weight: var(--fw-md);
	font-size: 17px;
	line-height: var(--it-hg-md);
	color: var(--text-white-color);
	margin: var(--mg-md);
	text-align: center;
`

export const ButtonWrap = styled.div`
	margin-top: 20px;
	width: 100%;
`
export const ArrowImg = styled.img`
	height: 12px;
	width: 12px;
`

export const OptionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`

export const Line = styled.h2`
	border: none;
	width: 320px;
	margin-top: 0;
	border-bottom: 2px solid #437ddb;
	box-shadow: 0 16px 38px -9px #437ddb;
	margin: 0px auto 10px;
	margin-left: -10px;
	z-index: -1;
	transform: translateY(-25.8px);
	margin-bottom: 0;
`
